const newsData = [
  {
    Img: require("../../assets/news/HandMade.jpg"),
    Title: "Witamy Na Nowej Odsłonie Naszej Strony!",
    Description:
      "Dziękujemy za Państwa zainteresowanie i zapraszamy do zapoznanie się z nowymi zdjęciami, instrukcjami oraz naszą pełną ofertą! Na...",
    Link: "/"
  },
  {
    Img: require("../../assets/news/20180408_152350-1024x867.jpg"),
    Title: "HandMade To Nie Tylko Pusty Slogan!",
    Description:
      "Drodzy Państwo, kupując nasze deski macie pewność, że każda z nich została wykonanie ręcznie, bez powtarzalnych, wytłaczanych wzorów. Również...",
    Link: "/handmade"
  },
  {
    Img: require("../../assets/news/20180228_130615-1024x768.jpg"),
    Title: "Rozwijamy Się Dla Państwa",
    Description:
      "Wieloletnia ciężka praca oraz zaufanie naszych klientów pozwoliło nam rozwinąć naszą siatkę sprzedaży i dystrybucji. Można nas znaleźć już...",
    Link: "/gdzie-nas-znalezc"
  },
  {
    Img: require("../../assets/news/20180322_201108-1024x790.jpg"),
    Title: "Wielki Powrót Klasyki!",
    Description:
      "Przypominamy, że każdy nasz kolor oraz wzór można zamówić w postaci jodełki klasycznej, francuskiej oraz węgierskiej.",
    Link: "/podlogi"
  }
];

export default newsData;
